import { InjectionToken } from '@angular/core';
import { IRouteItem } from '@shared/interfaces';

export const APP_ROUTES: InjectionToken<IRouteItem[]> = new InjectionToken('APP_ROUTES');
